import { NgModule } from '@angular/core';
import { NcExcelService } from './excel.service';

@NgModule({
    providers: [NcExcelService]
})
export class NcExcelServiceModule { }